export const STRINGS = {
  title: "Wie war Ihre Erfahrung?",
  subtitle:
    "Ein paar Sterne, ein paar Worte — das hilft echten Menschen, sich zu entscheiden, und uns, immer ein Stück besser zu werden.",

  questionRecommend:
    "Wie wahrscheinlich ist es, dass Sie {company} einer Freundin, einem Freund oder einer Kollegin/einem Kollegen weiterempfehlen würden?",
  questionOverall: "Wie zufrieden sind Sie insgesamt mit {company}?",
  questionQuality: "Wie bewerten Sie die Qualität der Leistung von {company}?",
  questionAdvice:
    "Wie zufrieden waren Sie mit der Beratung oder Betreuung durch {company}?",
  questionAgain:
    "Wie wahrscheinlich ist es, dass Sie {company} erneut nutzen oder beauftragen würden?",

  scaleHintLow: "Sehr unwahrscheinlich",
  scaleHintHigh: "Sehr wahrscheinlich",

  freitextLabel: "Ihre persönliche Erfahrung",
  freitextPlaceholder:
    "Was hat Ihnen besonders gefallen? Wo sehen Sie Verbesserungsbedarf? Erzählen Sie gerne in eigenen Worten …",
  freitextCounter: (count: number) =>
    `${count.toLocaleString("de-DE")} / 1.000 Zeichen`,
  freitextThirdPartyHint:
    "Bitte nennen Sie keine Namen anderer Personen. Ihre Bewertung kann öffentlich angezeigt werden — andere Personen könnten sonst ungewollt darin auftauchen.",

  contactSectionTitle: "Ihre Angaben",
  firstNameLabel: "Vorname",
  firstNamePlaceholder: "z. B. Julia",
  lastNameLabel: "Nachname",
  lastNamePlaceholder: "z. B. Klein",
  emailLabel: "E-Mail Adresse",
  emailPlaceholder: "ihre.adresse@example.com",
  emailInfo:
    "Wir benötigen Ihre E-Mail nur, um Ihre Bewertung zu verifizieren (Double-Opt-In). Sie wird nicht veröffentlicht und nicht für Werbung verwendet.",
  optionalMarker: "(optional)",
  requiredHint: "* Pflichtfeld",
  anonymousLabel: "Anonym bewerten: Mein Vor- und Nachname wird nicht angezeigt.",
  anonymousHint:
    "Wenn Sie anonym bewerten, wird Ihr Name weder öffentlich angezeigt noch dem bewerteten Unternehmen offengelegt. Angezeigt wird „Anonym\". Nur Trustleap kann Ihre Bewertung Ihnen zuordnen — allein, um die Echtheit zu prüfen.",
  consentStorageLabel:
    "Ich willige ein, dass meine Bewertung mit den angegebenen Daten gespeichert und dem bewerteten Unternehmen angezeigt wird. Ohne diese Einwilligung kann ich keine Bewertung abgeben. Ich kann sie jederzeit widerrufen — über den Widerrufs-Link in der Bestätigungs-E-Mail oder formlos per E-Mail an info@trust-leap.de.",
  consentPublicLabel:
    "Zusätzlich willige ich ein, dass meine Bewertung öffentlich auf den Landingpages des bewerteten Unternehmens angezeigt wird — mit meinem Anzeigenamen (oder „Anonym\", wenn ich anonym bewerte), meiner Sternebewertung und meinem Freitext, ohne Anmeldung für jeden Besucher sichtbar. Diese Einwilligung ist freiwillig; ich kann auch ohne sie bewerten und sie jederzeit widerrufen.",
  submit: "Bewertung abschicken",
  authenticityTitle: "Wie wir Echtheit sichern",
  authenticityNotice:
    "So sichern wir die Echtheit der Bewertungen: Eine Bewertung ist nur über einen persönlichen Einladungslink möglich. Die E-Mail-Adresse ist Pflicht und wird per Bestätigungslink überprüft (Double-Opt-In); Wegwerf-Adressen sind gesperrt, und wir setzen technische Prüfungen gegen Missbrauch ein. Ob eine bewertende Person Kundin oder Kunde des bewerteten Unternehmens war, prüfen wir nicht.",

  validationEmailMissing: "Bitte E-Mail-Adresse angeben.",
  validationEmailInvalid: "Ungültige E-Mail-Adresse.",

  pendingTitle: "Fast geschafft — bitte E-Mail bestätigen",
  pendingBody: (email: string) =>
    `Wir haben Ihnen einen Bestätigungs-Link an ${email} geschickt. Bitte klicken Sie auf den Link in der E-Mail — erst dann zählt Ihre Bewertung.`,
  pendingStepSubmitted: "Bewertung abgegeben",
  pendingStepConfirm: "E-Mail bestätigen",
  pendingStepPublished: "Veröffentlicht",
  pendingExpiry:
    "Der Link ist 48 Stunden gültig. Keine E-Mail erhalten? Bitte prüfen Sie auch den Spam-Ordner — manchmal landet sie dort.",
  pendingResend: "Erneut senden",
  pendingResendSending: "Wird gesendet …",

  thanksTitle: (firstName: string) =>
    firstName ? `Vielen Dank, ${firstName}!` : "Vielen Dank!",
  thanksBody:
    "Ihre Bewertung ist bestätigt und ab sofort sichtbar. Wir lesen jede einzelne Rückmeldung — Ihre hilft uns dabei, noch besser zu werden.",
  thanksJustNow: "Ihre Bewertung · vor wenigen Sekunden",

  promoterKicker: "Eine Idee zum Schluss",
  promoterTitle: "Sie waren begeistert? Werden Sie Promoter.",
  promoterBody: (company: string) =>
    `Als Promoter empfehlen Sie ${company} ganz unkompliziert weiter — und partizipieren an jedem erfolgreichen Abschluss. Kostenlos, ohne Vertrag, jederzeit kündbar.`,
  promoterBenefitLinkTitle: "Persönlicher Empfehlungslink",
  promoterBenefitLinkText:
    "Eine eigene Seite, die Sie per WhatsApp, Mail oder einfach im Gespräch teilen.",
  promoterBenefitPayTitle: "Beteiligung bei Abschluss",
  promoterBenefitPayText:
    "Faire Provision bei jeder Empfehlung, die zu einem Termin oder Abschluss führt.",
  promoterBenefitTransTitle: "Volle Transparenz",
  promoterBenefitTransText:
    "Sie sehen jederzeit, wo Ihre Empfehlungen stehen — kein „Black-Box-Marketing\".",
  promoterDisclaimer:
    "Kein Verkaufsdruck — wir erklären Ihnen erst alles in Ruhe.",
  promoterLater: "Vielleicht später",
  promoterCta: "Jetzt Promoter werden",

  errorAlreadyTitle: "Bereits bestätigt",
  errorAlreadyBody: (date: string) =>
    date
      ? `Ihre Bewertung wurde bereits am ${date} bestätigt und ist seitdem sichtbar. Sie müssen nichts weiter tun.`
      : "Ihre Bewertung wurde bereits bestätigt und ist seitdem sichtbar. Sie müssen nichts weiter tun.",
  errorExpiredTitle: "Link abgelaufen",
  errorExpiredBody:
    "Dieser Link ist nicht mehr gültig. Bitte fordern Sie über Ihren Berater einen frischen Bewertungslink an.",
  errorInvalidTitle: "Link nicht erkannt",
  errorInvalidBody:
    "Wir konnten diesen Link keiner Bewertung zuordnen. Bitte prüfen Sie, ob Sie den vollständigen Link kopiert haben.",
  errorDuplicateTitle: "Schon bewertet",
  errorDuplicateBody: (company: string) =>
    company
      ? `Sie haben ${company} bereits bewertet. Pro E-Mail-Adresse ist eine Bewertung möglich. Falls Sie Ihre Bewertung ändern möchten, wenden Sie sich bitte an Ihren Berater.`
      : "Sie haben bereits bewertet. Pro E-Mail-Adresse ist eine Bewertung möglich. Falls Sie Ihre Bewertung ändern möchten, wenden Sie sich bitte an Ihren Berater.",
  errorUsedTitle: "Link bereits verwendet",
  errorUsedBody:
    "Über diesen Link wurde bereits eine Bewertung abgegeben. Pro Link ist eine Bewertung möglich.",

  footerPrivacy: "Datenschutzerklärung",
  footerImprint: "Impressum",
  footerReportContent: "Inhalte melden",

  editTitle: "Bewertung überarbeiten",
  editSubtitle:
    "Passen Sie Ihre Sterne und Ihren Text an. Zum Speichern bestätigen Sie anschließend erneut Ihre E-Mail.",
  editReviewerInfo: (name: string, email: string) =>
    name ? `Bewertung von ${name} · ${email}` : `Bewertung von ${email}`,
  editReviewerAnonymous: "Diese Bewertung wird anonym veröffentlicht.",
  editSubmit: "Änderungen speichern",
  editPendingTitle: "Fast geschafft — bitte E-Mail bestätigen",
  editPendingBody: (email: string) =>
    `Wir haben Ihnen einen Bestätigungs-Link an ${email} geschickt. Erst nach dem Klick wird Ihre überarbeitete Bewertung übernommen.`,
  editPendingExpiry:
    "Der Link ist 48 Stunden gültig. Keine E-Mail erhalten? Bitte prüfen Sie auch den Spam-Ordner.",

  revokeTitle: "Bewertung widerrufen",
  revokeBody:
    "Mit einem Klick löschen wir Ihre Bewertung. Das lässt sich nicht rückgängig machen.",
  revokeSubmit: "Bewertung widerrufen",
  revokeSuccessTitle: "Ihre Bewertung wurde widerrufen",
  revokeSuccessBody:
    "Wir haben Ihre Bewertung gelöscht. Das bewertete Unternehmen sieht sie nicht mehr. Von den Landingpages des Unternehmens wird sie ebenfalls entfernt, das kann einige Minuten dauern.",
  revokeSuccessHint:
    "Sie müssen nichts weiter tun. Fragen zum Datenschutz beantworten wir unter info@trust-leap.de.",
  revokeInvalidTitle: "Dieser Link ist nicht mehr gültig",
  revokeInvalidBody:
    "Der Widerrufs-Link wurde bereits verwendet, oder zu diesem Link gibt es keine Bewertung mehr. Möglicherweise ist Ihre Bewertung bereits gelöscht.",
  revokeInvalidContact:
    "Wenn Sie unsicher sind, schreiben Sie uns an info@trust-leap.de. Wir prüfen das für Sie.",

  disputeTitle: "Ihre Bewertung wird geprüft",
  disputeIntro: (company: string) =>
    `${company} hat Ihre Bewertung beanstandet. Bevor wir entscheiden, möchten wir Ihre Sicht dazu hören.`,
  disputeReviewHeading: "Ihre Bewertung",
  disputeServiceLine: (service: string) => `Leistung: ${service}`,
  disputeDeadline: (date: string) =>
    `Bitte antworten Sie bis zum ${date}. Ohne Rückmeldung entscheiden wir anhand der Angaben, die uns vorliegen.`,
  disputeFieldLabel: "Wann und wofür hatten Sie Kontakt?",
  disputePlaceholder:
    "Zum Beispiel: Beratungstermin am 3. Februar in der Filiale Musterstadt.",
  disputeSubmit: "Nachweis einreichen",
  disputeTooLong: (max: number) =>
    `Bitte fassen Sie sich kürzer, maximal ${max} Zeichen.`,
  disputeEmpty: "Bitte beschreiben Sie den Kontakt kurz.",
  disputeSuccessTitle: "Vielen Dank, wir haben Ihre Angaben erhalten",
  disputeSuccessBody:
    "Wir prüfen den Fall und melden uns, sobald entschieden ist. Ihre Bewertung bleibt bis dahin sichtbar.",

  legalsEmpty: "Dieses Dokument ist derzeit nicht verfügbar.",

  loading: "Wird geladen …",
  genericError:
    "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
  resendSuccess: "E-Mail erneut gesendet",
  resendRateLimit: "Zu viele Anfragen. Bitte später erneut versuchen.",
  resendMaxReached:
    "Sie haben die maximale Anzahl an erneuten Sendungen erreicht.",
  resendCooldown: (seconds: number) =>
    `Bitte warten Sie noch ${seconds} Sekunden vor dem nächsten Versuch.`,
} as const;

export function tpl(s: string, vars: Record<string, string | number>): string {
  return s.replace(/\{(\w+)\}/g, (_match, k: string) =>
    String(vars[k] ?? "")
  );
}

export interface ParsedLink {
  before: string;
  link: string;
  after: string;
}

export function parseLinkMarker(s: string): ParsedLink | null {
  const m = s.match(/^(.*?)\[(.+?)\](.*)$/s);
  if (!m) return null;
  return { before: m[1], link: m[2], after: m[3] };
}
